import type { Dictionary, Translation } from '@/i18n/types';

const ro = {
  eyebrowCatalog: 'CATALOG AKIS · PUBLIC',
  badgePublic: 'Public',
  navHome: 'Acasă',

  advisorsHeading: 'Consilieri agricoli',
  advisorsLead:
    'Explorați rețeaua națională de consilieri agricoli: specializare, acoperire teritorială, atestare și date de contact.',
  advisorsActive: 'Consilieri activi',
  advisorsZones: 'Zone acoperite',
  advisorsCoverageBefore: 'Acoperirea teritorială este vizibilă și pe',
  advisorsCoverageLink: 'harta interactivă AKIS',
  advisorsCoverageAfter: '.',
  advisorsGapsHeading: 'Raioane fără consilieri',
  advisorsGapsLead: 'Zone fără niciun consilier înregistrat ({{count}} din {{total}}):',
  advisorsGapsNone: 'Toate zonele active au cel puțin un consilier înregistrat.',
  advisorsDomainsHeading: 'Acoperirea pe domenii de competență',
  advisorsDomainsAria: 'Domenii de competență',
  advisorsDomainFilterBy: 'Filtrează după domeniul {{domain}}',
  advisorsDomainAdvisors: '{{count}} consilieri',
  advisorsDomainAdvisors_one: 'un consilier',
  advisorsDomainAdvisors_other: '{{count}} de consilieri',
  advisorsDomainGaps: '{{count}} raioane fără acoperire',
  advisorsDomainGaps_one: 'un raion fără acoperire',
  advisorsDomainGaps_other: '{{count}} de raioane fără acoperire',
  advisorsDomainNoAdvisors: 'niciun consilier în acest domeniu',
  advisorsDomainFilter: 'Domeniu de competență',
  advisorsDomainFilterAria: 'Filtrează consilierii după domeniul de competență',
  advisorsAllDomains: 'Toate domeniile',
  advisorsSearchLabel: 'Caută consilieri',
  advisorsSearchPlaceholder: 'Nume, specializare, raion sau domeniu',
  advisorsCtaLead: 'Sunteți consilier agricol?',
  advisorsCtaLink: 'Înregistrați-vă profilul',
  advisorsAvailable: 'Consilieri disponibili',
  advisorsAttested: 'Atestat',
  advisorsAttestedSince: 'Atestat din {{year}}',
  advisorsValidatedSince: 'Validat din {{year}}',
  advisorsEmailAria: 'Trimite e-mail lui {{name}}: {{email}}',
  advisorsPhoneAria: 'Apelează {{name}}: {{phone}}',
  advisorsSeeOnMap: 'Vezi pe hartă',
  advisorsEmptyAll: 'Niciun consilier înregistrat deocamdată.',
  advisorsEmptyFiltered: 'Niciun consilier găsit pentru criteriile selectate.',
  advisorsEmptyHintBefore: 'Încearcă să modifici căutarea sau',
  advisorsEmptyHintLink: 'resetează filtrele',

  libraryHeading: 'Biblioteca digitală AKIS',
  libraryLead: 'Ghiduri, standarde, rapoarte, studii și materiale de instruire, cu acces deschis.',
  librarySearchLabel: 'Caută resurse',
  librarySearchPlaceholder: 'Titlu, temă sau cuvinte-cheie',
  libraryDownload: 'Descarcă',
  librarySource: 'Sursă externă',
  libraryCite: 'Citează',
  savedLibraryPageTitle: 'Resurse salvate',
  savedLibraryTitle: 'Resurse salvate',
  savedLibraryEmptyHint:
    'Folosiți butonul „Salvează” de pe o resursă din biblioteca digitală și o veți găsi aici.',
  savedLibraryOpenCatalogue: 'Deschide biblioteca digitală',
  savedLibraryLoadFailed: 'Resursele salvate nu au putut fi încărcate.',
  savedLibraryRetry: 'Încearcă din nou',
  savedLibraryIntro: 'Din biblioteca digitală, cele mai recente întâi.',
  savedLibraryEmpty: 'Nu ați salvat încă nicio resursă.',
  savedLibrarySearchPlaceholder: 'Caută în resursele salvate',
  savedLibraryFilterLabel: 'Filtrează după tip',
  savedLibraryFilterAll: 'Toate',
  savedLibraryFilterDocuments: 'Documente',
  savedLibraryFilterVideo: 'Video',
  savedLibraryNoMatch: 'Niciun rezultat pentru filtrele selectate.',
  savedLibraryTypeDocument: 'Document',
  savedLibraryTypeVideo: 'Video',
  savedLibraryOpen: 'Descarcă',
  savedLibraryRemove: 'Elimină',
  savedLibraryBreadcrumbParent: 'Rapoarte și publicații',
  librarySavedLink: 'Resursele mele salvate',
  librarySavedNotice: 'Resursa a fost salvată.',
  savedLibraryDownloadAria: 'Descarcă: {{title}}',
  savedLibrarySource: 'Deschide sursa',
  savedLibrarySourceAria: 'Deschide sursa: {{title}} (se deschide într-o filă nouă)',
  savedLibraryRemoveAria: 'Elimină „{{title}}” din salvate',
  savedLibraryPlayAria: 'Redă video: {{title}}',
  savedLibrarySourceFile: 'Fișier video',
  savedLibraryCount: 'Se afișează {{from}}–{{to}} din {{count}} resurse salvate.',
  savedLibraryCount_one: 'Se afișează o resursă salvată.',
  savedLibraryCount_other: 'Se afișează {{from}}–{{to}} din {{count}} de resurse salvate.',
  savedLibraryPaginationAria: 'Paginare resurse salvate',
  savedLibraryTableAria: 'Lista resurselor salvate',
  savedLibraryColTitle: 'Titlu',
  savedLibraryColType: 'Tip',
  savedLibraryColYear: 'An',
  savedLibraryColSaved: 'Salvat la',
  savedLibraryColActions: 'Acțiuni',
  videoDialogClose: 'Închide',
  libraryNewTab: '(se deschide într-o filă nouă)',
  librarySave: 'Salvează',
  librarySaved: 'Salvat',
  librarySaveHint: 'Autentificați-vă pentru a salva resurse.',
  libraryCiteHide: 'Ascunde citarea',
  libraryCiteHeading: 'Citare automată',
  libraryCiteLoading: 'Se generează citarea…',
  libraryCiteError: 'Citarea nu a putut fi generată. Încercați din nou.',
  libraryCiteCopy: 'Copiază',
  libraryCiteCopied: 'Copiat',
  libraryFiltersToggle: 'Căutare avansată',
  libraryFilterAuthor: 'Autor',
  libraryFilterInstitution: 'Instituție',
  libraryFilterYear: 'An de publicare',
  libraryFilterType: 'Tip de document',
  libraryFilterDomain: 'Domeniu tematic',
  libraryFilterKeyword: 'Cuvânt-cheie',
  paginationAria: 'Paginare bibliotecă',
  paginationPrevious: 'Anterior',
  paginationNext: 'Următor',
  paginationPageAria: 'Pagina {{page}}',
  paginationCurrentAria: 'Pagina curentă, {{page}}',
  videoUnsupported:
    'Browserul dumneavoastră nu poate reda acest material video. Îl puteți descărca.',
  libraryFilterAny: 'Toate',
  libraryFilterApply: 'Filtrează',
  servicesReset: 'Resetează',
  libraryTypeGUIDE: 'Ghid',
  libraryTypeSTANDARD: 'Standard',
  libraryTypePOLICY: 'Politică publică',
  libraryTypeREPORT: 'Raport',
  libraryTypeSTUDY: 'Studiu',
  libraryTypePUBLICATION: 'Publicație',
  libraryTypeTRAINING_MATERIAL: 'Material de instruire',
  libraryTypeVIDEO: 'Video',
  libraryNationalEyebrow: 'Resurse naționale',
  librarySourceLabel: 'Sursă',
  librarySourceNational: 'Doar naționale',
  librarySourceInternational: 'Doar internaționale',
  librarySearchEmpty: 'Nicio resursă găsită pentru căutarea ta.',
  libraryNationalHidden: 'Filtrat la resurse internaționale — vezi secțiunea de mai jos.',
  libraryExternalEyebrow: 'Resurse internaționale',
  libraryExternalHeading: 'Caută și în bibliotecile externe',
  libraryExternalCta: 'Caută în {{name}}',

  trainingsHeading: 'Calendar instruiri',
  servicesHeading: 'Servicii de consiliere agricolă',
  researchHeading: 'Organizații de cercetare și inovare',
  fundingHeading: 'Subvenții și granturi',
  agenciesHeading: 'Agenții de sprijin și proiecte strategice',
  communityHeading: 'Comunitate, forumuri și discuții',

  sitemapHeading: 'Hartă site',
  sitemapAbout: 'Despre proiect',
  sitemapCatalog: 'Catalogul serviciilor',
  sitemapEvents: 'Calendar de evenimente',
  sitemapNews: 'Știri și articole',
  sitemapMap: 'Harta AKIS',
  sitemapSearch: 'Căutare',
  sitemapContact: 'Contact',
  sitemapTerms: 'Politica de utilizare',
  sitemapPrivacy: 'Politica de confidențialitate',
  sitemapCookies: 'Politica cookies',
  sitemapAccessibility: 'Declarație de accesibilitate',
} as const;

const en = {
  eyebrowCatalog: 'AKIS CATALOGUE · PUBLIC',
  badgePublic: 'Public',
  navHome: 'Home',

  advisorsHeading: 'Agricultural advisers',
  advisorsLead:
    'Explore the national network of agricultural advisers: specialisation, territorial coverage, attestation and contact details.',
  advisorsActive: 'Active advisers',
  advisorsZones: 'Zones covered',
  advisorsCoverageBefore: 'Territorial coverage is also shown on',
  advisorsCoverageLink: 'the interactive AKIS map',
  advisorsCoverageAfter: '.',
  advisorsGapsHeading: 'Districts with no adviser',
  advisorsGapsLead: 'Zones with no registered adviser ({{count}} of {{total}}):',
  advisorsGapsNone: 'Every active zone has at least one registered adviser.',
  advisorsDomainsHeading: 'Coverage by domain of competence',
  advisorsDomainsAria: 'Domains of competence',
  advisorsDomainFilterBy: 'Filter by the {{domain}} domain',
  advisorsDomainAdvisors: '{{count}} advisers',
  advisorsDomainAdvisors_one: 'one adviser',
  advisorsDomainAdvisors_other: '{{count}} advisers',
  advisorsDomainGaps: '{{count}} districts uncovered',
  advisorsDomainGaps_one: 'one district uncovered',
  advisorsDomainGaps_other: '{{count}} districts uncovered',
  advisorsDomainNoAdvisors: 'no advisers in this domain',
  advisorsDomainFilter: 'Domain of competence',
  advisorsDomainFilterAria: 'Filter the advisers by domain of competence',
  advisorsAllDomains: 'All domains',
  advisorsSearchLabel: 'Search advisers',
  advisorsSearchPlaceholder: 'Name, specialisation, district or domain',
  advisorsCtaLead: 'Are you an agricultural adviser?',
  advisorsCtaLink: 'Register your profile',
  advisorsAvailable: 'Available advisers',
  advisorsAttested: 'Attested',
  advisorsAttestedSince: 'Attested since {{year}}',
  advisorsValidatedSince: 'Validated since {{year}}',
  advisorsEmailAria: 'Email {{name}}: {{email}}',
  advisorsPhoneAria: 'Call {{name}}: {{phone}}',
  advisorsSeeOnMap: 'See on the map',
  advisorsEmptyAll: 'No advisers registered yet.',
  advisorsEmptyFiltered: 'No advisers matched the selected criteria.',
  advisorsEmptyHintBefore: 'Try changing your search or',
  advisorsEmptyHintLink: 'reset the filters',

  libraryHeading: 'AKIS digital library',
  libraryLead: 'Open-access guides, standards, reports, studies and training materials.',
  librarySearchLabel: 'Search resources',
  librarySearchPlaceholder: 'Title, topic or keywords',
  libraryDownload: 'Download',
  librarySource: 'External source',
  libraryCite: 'Cite',
  savedLibraryPageTitle: 'Saved resources',
  savedLibraryTitle: 'Saved resources',
  savedLibraryEmptyHint:
    'Use the “Save” button on a resource in the digital library and you will find it here.',
  savedLibraryOpenCatalogue: 'Open the digital library',
  savedLibraryLoadFailed: 'Your saved resources could not be loaded.',
  savedLibraryRetry: 'Try again',
  savedLibraryIntro: 'From the digital library, most recent first.',
  savedLibraryEmpty: 'You have not saved any resources yet.',
  savedLibrarySearchPlaceholder: 'Search your saved resources',
  savedLibraryFilterLabel: 'Filter by type',
  savedLibraryFilterAll: 'All',
  savedLibraryFilterDocuments: 'Documents',
  savedLibraryFilterVideo: 'Video',
  savedLibraryNoMatch: 'No results for the selected filters.',
  savedLibraryTypeDocument: 'Document',
  savedLibraryTypeVideo: 'Video',
  savedLibraryOpen: 'Download',
  savedLibraryRemove: 'Remove',
  savedLibraryBreadcrumbParent: 'Reports and publications',
  librarySavedLink: 'My saved resources',
  librarySavedNotice: 'The resource has been saved.',
  savedLibraryDownloadAria: 'Download: {{title}}',
  savedLibrarySource: 'Open the source',
  savedLibrarySourceAria: 'Open the source: {{title}} (opens in a new tab)',
  savedLibraryRemoveAria: 'Remove “{{title}}” from saved',
  savedLibraryPlayAria: 'Play video: {{title}}',
  savedLibrarySourceFile: 'Video file',
  savedLibraryCount: 'Showing {{from}}–{{to}} of {{count}} saved resources.',
  savedLibraryCount_one: 'Showing 1 saved resource.',
  savedLibraryCount_other: 'Showing {{from}}–{{to}} of {{count}} saved resources.',
  savedLibraryPaginationAria: 'Saved resources pagination',
  savedLibraryTableAria: 'Saved resources list',
  savedLibraryColTitle: 'Title',
  savedLibraryColType: 'Type',
  savedLibraryColYear: 'Year',
  savedLibraryColSaved: 'Saved on',
  savedLibraryColActions: 'Actions',
  videoDialogClose: 'Close',
  libraryNewTab: '(opens in a new tab)',
  librarySave: 'Save',
  librarySaved: 'Saved',
  librarySaveHint: 'Sign in to save resources.',
  libraryCiteHide: 'Hide citation',
  libraryCiteHeading: 'Automatic citation',
  libraryCiteLoading: 'Generating the citation…',
  libraryCiteError: 'The citation could not be generated. Please try again.',
  libraryCiteCopy: 'Copy',
  libraryCiteCopied: 'Copied',
  libraryFiltersToggle: 'Advanced search',
  libraryFilterAuthor: 'Author',
  libraryFilterInstitution: 'Institution',
  libraryFilterYear: 'Publication year',
  libraryFilterType: 'Document type',
  libraryFilterDomain: 'Thematic domain',
  libraryFilterKeyword: 'Keyword',
  paginationAria: 'Library pagination',
  paginationPrevious: 'Previous',
  paginationNext: 'Next',
  paginationPageAria: 'Page {{page}}',
  paginationCurrentAria: 'Current page, {{page}}',
  videoUnsupported: 'Your browser cannot play this video. You can download it instead.',
  libraryFilterAny: 'All',
  libraryFilterApply: 'Filter',
  servicesReset: 'Reset',
  libraryTypeGUIDE: 'Guide',
  libraryTypeSTANDARD: 'Standard',
  libraryTypePOLICY: 'Public policy',
  libraryTypeREPORT: 'Report',
  libraryTypeSTUDY: 'Study',
  libraryTypePUBLICATION: 'Publication',
  libraryTypeTRAINING_MATERIAL: 'Training material',
  libraryTypeVIDEO: 'Video',
  libraryNationalEyebrow: 'National resources',
  librarySourceLabel: 'Source',
  librarySourceNational: 'National only',
  librarySourceInternational: 'International only',
  librarySearchEmpty: 'No resources matched your search.',
  libraryNationalHidden: 'Filtered to international resources — see the section below.',
  libraryExternalEyebrow: 'International resources',
  libraryExternalHeading: 'Search the external libraries too',
  libraryExternalCta: 'Search {{name}}',

  trainingsHeading: 'Training calendar',
  servicesHeading: 'Agricultural advisory services',
  researchHeading: 'Research and innovation organisations',
  fundingHeading: 'Subsidies and grants',
  agenciesHeading: 'Support agencies and strategic projects',
  communityHeading: 'Community, forums and discussions',

  sitemapHeading: 'Sitemap',
  sitemapAbout: 'About the project',
  sitemapCatalog: 'Service catalogue',
  sitemapEvents: 'Events calendar',
  sitemapNews: 'News and articles',
  sitemapMap: 'AKIS map',
  sitemapSearch: 'Search',
  sitemapContact: 'Contact',
  sitemapTerms: 'Terms of use',
  sitemapPrivacy: 'Privacy policy',
  sitemapCookies: 'Cookie policy',
  sitemapAccessibility: 'Accessibility statement',
} satisfies Translation<keyof typeof ro>;

export const publicRegistry = { ro, en } satisfies Dictionary;

export type PublicRegistryKey = keyof typeof ro;
